/**
 * PATH: packages/email-hub/src/feature/components/email-reader/ReaderStates.tsx
 * FILE_ID: EMAILHUB-EMAILREADER-STATES-001
 * PURPOSE: Render empty, cold-loading, and error reader states.
 */
import { AlertCircle, RefreshCw } from 'lucide-react'

export function ReaderEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center h-full text-muted-foreground">
      <p className="text-sm">Select an email to read.</p>
    </div>
  )
}

export function ReaderLoadingState() {
  return (
    <div className="flex items-center justify-center h-full">
      <RefreshCw className="h-5 w-5 animate-spin text-primary" />
      <span className="ml-2 text-sm text-muted-foreground">
        Loading email...
      </span>
    </div>
  )
}

export function ReaderErrorState({
  error,
  onBack,
  backLabel,
}: {
  error: string | null
  onBack: () => void
  backLabel: string
}) {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <AlertCircle className="h-8 w-8 text-destructive mb-2" />
      <p className="text-destructive text-sm">{error || 'Email not found'}</p>
      <button
        type="button"
        onClick={onBack}
        className="mt-4 px-4 py-2 text-xs bg-primary text-primary-foreground rounded-lg hover:bg-primary/90"
      >
        {backLabel}
      </button>
    </div>
  )
}
